import { ref, unref, onMounted } from 'vue'
import { Graph, StringExt, Edge } from '@antv/x6'
import { Dnd } from '@antv/x6-plugin-dnd'
import { createGraphPlugin } from './initPlugins'
import { createGraphListener } from './listenerGraphEvent'
import { options as defaultOptions } from './config'
// @ts-ignore
export function useGraphRegister(
  id: string,
  options: any,
  flowConfigData: any,
  currentNodeId: any
): any {
  const graph = ref<Graph>({} as Graph)
  const dnd = ref<Dnd>()
  onMounted(() => {
    const container = document.getElementById(id)
    if (!container) {
      console.error('没有对应的container!')
    }
    graph.value = new Graph({
      ...defaultOptions,
      ...options,
      container,
      connecting: {
        router: 'manhattan',
        connector: {
          name: 'normal'
        },
        anchor: 'center',
        connectionPoint: 'anchor',
        allowBlank: false,
        allowNode: false,
        snap: {
          radius: 20
        },
        createEdge() {
          return unref(graph)!.createEdge({
            shape: 'customer-edge',
            attrs: {},
            zIndex: -1
          })
        },
        validateConnection({ sourceCell, targetCell }) {
          if (sourceCell! === targetCell!) {
            return false
          }
          return !!Infinity
        },
        validateEdge({ edge }) {
          const {
            source: { cell: cellId }
          } = edge.toJSON()
          const currentNode = this.getCellById(cellId)
          const outEdge = this.getOutgoingEdges(currentNode)
          const nodeEdgeAddition = outEdge?.reduce(
            (pre, edge: Edge) => {
              const {
                target: { cell }
              } = edge.toJSON()
              pre[cell] = pre[cell] ? pre[cell].concat(edge) : [edge]
              return pre
            },
            {} as Record<string, Edge[]>
          )

          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          Object.entries(nodeEdgeAddition!).forEach(([_item, v]) => {
            if (v.length > 1) {
              const [edge] = v
              this.removeCell(edge)
            }
          })

          if (outEdge!.length > 1) {
            const endEdge = outEdge?.filter(edge => {
              const {
                target: { cell: cellId }
              } = edge.toJSON()
              return cellId === '-1'
            })
            if (endEdge!.length > 1) {
              const [edge] = endEdge as Edge[]
              this.removeCell(edge)
            }
          }
          return true
        }
      }
    }) as Graph
    dnd.value = new Dnd({
      target: unref(graph) as Graph,
      scaled: false
    })
    createGraphPlugin(unref(graph) as Graph, { ...defaultOptions, ...options })
    createGraphListener(unref(graph) as Graph, flowConfigData, currentNodeId, options.disabled)
  })
  const startDrag = (e: any, com: any, extendData: any = {}) => {
    const { type } = com

    const node = graph.value!.createNode({
      id: StringExt.uuid(),
      shape: type === 'APPROVAL' ? 'flow-approval-comp' : 'flow-comp',
      attrs: {
        body: {
          stroke: '#8f8f8f',
          strokeWidth: 1,
          fill: '#fff'
        }
      },
      data: {
        ...com,
        ...extendData
      },
      ports: [
        {
          id: '0',
          group: 'top'
        },
        {
          id: '3',
          group: 'bottom'
        },
        {
          id: '1',
          group: 'left'
        },
        {
          id: '2',
          group: 'right'
        }
      ]
    })
    dnd.value!.start(node, e as any)
  }

  return { graph, dnd, startDrag }
}
